import {AxiosError, AxiosResponse} from 'axios';
import {useMutation} from 'react-query';
import postCheckOrderOtp from './postCheckOrderOtp';
import {IPostCheckOrderOtpPayload} from './types';

const usePostCheckOrderOtp = (
  handleAfterSuccess?: (response: AxiosResponse<any>) => void,
  handleOnError?: (statusCode: number | null) => void,
) => {
  return useMutation({
    mutationFn: (payload: IPostCheckOrderOtpPayload) =>
      postCheckOrderOtp(payload),

    onSuccess: response => {
      handleAfterSuccess?.(response);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      const status = error.response?.status ?? null;
      handleOnError?.(status);
    },
  });
};

export default usePostCheckOrderOtp;
